class s extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path d="M8 9a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z"></path><path d="m8 15-4.218-4.974a17.852 17.852 0 0 1-.174-.226A5.444 5.444 0 0 1 2.5 6.5a5.5 5.5 0 1 1 11 0 5.442 5.442 0 0 1-1.107 3.299h-.001s-.15.198-.172.225L8 15ZM4.406 9.197s.117.155.144.188L8 13.454l3.455-4.075.14-.183A4.45 4.45 0 0 0 12.5 6.5a4.5 4.5 0 1 0-9 0 4.453 4.453 0 0 0 .906 2.697Z"></path></svg>';
  }
}
const t = "pi-mod-locations";
customElements.get(t) || customElements.define(t, s);
export {
  s as default
};
